(function () {
  window.__teaQuizRecoLoaded = true;
  window.__teaQuizRecoVersionLoaded = 20;
  window.__teaQuizShowRedirectOverlay = function () {
    return false;
  };

  if (window.__teaQuizRecoV8EntryV5) return;
  window.__teaQuizRecoV8EntryV5 = 1;

  function isOnHubResultsPage() {
    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '') || '/';
    if (path === '/pages/quiz-results' || path === root + '/pages/quiz-results') return true;
    try {
      return new URLSearchParams(window.location.search).get('view') === 'quiz-results';
    } catch (error) {
      return window.location.search.indexOf('view=quiz-results') !== -1;
    }
  }

  if (isOnHubResultsPage()) {
    window.__teaQuizHubRedirectLock = 1;
    if (window.__teaQuizClearRedirectOverlay) {
      window.__teaQuizClearRedirectOverlay();
    }
    return;
  }

  if ((window.__teaQuizRecoVersionLoaded || 0) >= 20) return;
  if (document.querySelector('script[data-tea-quiz-reco-v9], script[src*="tea-quiz-reco-v9.js"]')) {
    return;
  }

  var ref =
    document.currentScript ||
    document.querySelector('script[src*="tea-quiz-reco-v8.js"]');
  if (!ref || !ref.src) return;

  var base = ref.src.replace(/tea-quiz-reco-v8\.js.*$/, '');
  var script = document.createElement('script');
  script.src = base + 'tea-quiz-reco-v9.js?_=' + Date.now();
  script.defer = true;
  script.setAttribute('data-tea-quiz-reco-v9', '');
  document.head.appendChild(script);
})();
